import { Container, Grid, Typography, Box, Theme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

interface CollegeDegree {
  collegeName: string;
  degree: string | null;
  degreeYear: number | null;
}
const Education = ({ collegeDegrees }: { collegeDegrees: CollegeDegree[] }) => {
  const isMobileOrSmaller = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const degreeeAndYearHelper = (degree: string | null, degreeYear: number | null) => {
    if (degree && degreeYear) {
      return `${degree}, ${degreeYear}`;
    }
    if (degree) {
      return degree;
    }
    return degreeYear;
  };
  return (
    <Grid item xs={12}>
      <Container maxWidth="md">
        <Box pb={2}>
          <Typography variant={isMobileOrSmaller ? 'h2' : 'h1'}>Education</Typography>
          {collegeDegrees.map(({ collegeName, degree, degreeYear }) => {
            return (
              <div key={`${degree}-${degreeYear}`}>
                {collegeName !== '' && (
                  <Typography variant="h4" mt={3}>
                    {collegeName}
                  </Typography>
                )}
                <Typography variant="body2" color="secondary">
                  {degreeeAndYearHelper(degree, degreeYear)}
                </Typography>
              </div>
            );
          })}
        </Box>
      </Container>
    </Grid>
  );
};

export default Education;
